import React, { Component } from "react";
import { Route, RouteComponentProps, withRouter } from "react-router";
import { NavLink, BrowserRouter, Switch } from "react-router-dom";
import { connect } from "react-redux";
import clsx from "clsx";
import debounce from "lodash.debounce";
import { IMarketActionDispatches, mapMarketDispatchToProps } from "../../redux/actions/market";
import { IMarketState, mapMarketStateToProps } from "../../redux/reducers/market";
import UILoader from "../ui/UILoader";
import UISearchInput from "../ui/UISearchInput";
import { WidgetProps } from "../widgets";
import { withAuth, IAuthProps } from "../../laco-common/auth/AuthContext";
import theme from "../../laco-common/theme";
import UserRoleContent from "../auth/permissions/UserRoleContent";
import ImageView from "../ui/Media/ImageView";
import { IEvent } from "../../laco-common/base/models/event";
import MessageDetail from "./MessageDetail";
import { getDateDisplay } from "../../utils/date-utils";
import { displayDateTime2 } from "../../laco-common/helpers";
import "./Ads.scss";

type MessagesState = {
	searchQuery: string;
	loading: boolean;
};

export function renderDateAndGroup(msg: IEvent) {
	return (
		<div className="ad-date">
			{getDateDisplay(new Date(msg.created_at), null)} {renderGroup.call(this, msg)}
		</div>
	);
}

export function renderGroup(msg: IEvent) {
	if (msg.group_id) {
		const groupName: string = this.props.groupsMap[msg.group_id];
		if (groupName) return `- ${this.props.groupsMap[msg.group_id]}`;
	}
	return "";
}

export function renderLink(msg: IEvent) {
	if (!msg.link) return null;
	return (
		<div
			className="ad-price ui-text-overflow"
			style={{ width: "100%" }}
			onClick={(e) => {
				e.stopPropagation();
			}}
		>
			<a href={msg.link} target="_blank" className="firewire-orange-link">
				{msg.link_text || msg.link}
			</a>
		</div>
	);
}

type MessagesProps = WidgetProps;

class Messages extends Component<
	IMarketActionDispatches & IMarketState & MessagesProps & IAuthProps & RouteComponentProps,
	MessagesState
> {
	private readonly handleSearch = debounce(this.onSearch.bind(this), 400, { trailing: true });

	state = {
		searchQuery: "",
		loading: true,
	};

	get messages(): IEvent[] {
		if (this.state.searchQuery) {
			const q: string = this.state.searchQuery.toLowerCase();
			return this.props.messages.filter(
				(msg: IEvent) => msg.title.toLowerCase().includes(q) || msg.description.toLowerCase().includes(q)
			);
		}
		return this.props.messages || [];
	}

	componentDidMount() {
		console.log("Messages.componentDidMount()");
		this.props.loadGroups().then(() => {
			this.init();
		});
	}

	init(fromRouter?: boolean) {
		Promise.all([this.props.loadMessages(this.props.widget.widgetType === "messages-preview")]).finally(() => {
			this.setState({ loading: false });
		});
	}

	onSearch(val: string) {
		console.log("onSearch:", val);
		this.setState({ searchQuery: val });
	}

	renderEvent(msg: IEvent, color: string = "#ff9600") {
		if (!msg.eventDate) return null;
		return (
			<div
				className="ad-price d-inline-flex align-items-center"
				style={{ color, textDecoration: "underline", padding: "3px 0px", cursor: "pointer" }}
				onClick={(e) => {
					e.preventDefault();
					e.stopPropagation();
					this.props.history.push(`/events/${msg.id}`);
				}}
			>
				<i className="im im-date-o mr-1"></i>
				{displayDateTime2(msg.eventDate as number)}
			</div>
		);
	}

	renderMessages() {
		return (
			<div
				className={clsx(
					"container",
					this.props.isNested && "mt-3 mb-3",
					!this.props.isNested && "section-padding",
					this.props.widget.widgetType === "messages" && "pt-5",
					this.props.widget.widgetType === "messages-preview" && "pb-5"
				)}
			>
				{this.props.widget.widgetType === "messages-preview" && (
					<h1 className="highlighted mb-5">Members' Messages</h1>
				)}
				{this.props.widget.widgetType === "messages" && (
					<div className="d-flex">
						<UISearchInput
							className="mb-4 w-100 inverted"
							style={{ maxWidth: "100%" }}
							inputStyle={{ width: "100%" }}
							placeholder="Search messages"
							onSearch={this.handleSearch}
						/>
						{/* <UINoData msg="Post through Firewire" className="align-self-center" /> */}
					</div>
				)}

				<UserRoleContent roles={["admin", "user"]}>
					<div className="grid-container">
						{this.messages.map((msg: IEvent, i: number) => {
							return (
								<div
									className="ad-container"
									// style={{ backgroundColor: theme.colors.grey2 }}
									key={msg.id}
								>
									<NavLink to={`/messages/${msg.id}`} className="scale-in-image-view">
										{msg.media?.length && (
											<ImageView
												className="mss-image-view"
												image={msg.media[0]}
												viewWidth={250}
												viewHeight={200}
												displayEnlargeHover={false}
												displayThumb={false}
												renderContainer
											/>
										)}

										<div
											className="ad-detail w-100"
											// style={{ backgroundColor: theme.colors.grey2 }}
										>
											<h5>{msg.title}</h5>
											{this.renderEvent(msg)}
											{renderDateAndGroup.call(this, msg)}
											{renderLink.call(this, msg)}
										</div>
									</NavLink>
								</div>
							);
						})}
					</div>
				</UserRoleContent>
			</div>
		);
	}

	render() {
		if (this.state.loading) return <UILoader display={true} />;

		return (
			<div className={clsx(this.props.widget.widgetType === "messages-preview" && "pb-4")}>
				<BrowserRouter>
					<Switch>
						<Route
							path={"/messages/:id"}
							render={(props) => (
								<>
									{this.renderMessages()}
									<MessageDetail
										// {...props}
										// {...this.props}
										onClose={() => {
											// const originUrl: string = this.props.page.path;
											// props.history.push(`/${originUrl}`);
										}}
										onGoToEvent={(e, ev: IEvent) => {
											e.preventDefault();
											e.stopPropagation();
											this.props.history.push(`/events/${ev.id}`);
										}}
									/>
								</>
							)}
						/>
						<Route path="/" render={(props) => this.renderMessages()} />
					</Switch>
				</BrowserRouter>
				{this.props.widget.widgetType === "messages-preview" && (
					<div className="">
						<div className="container pb-5">
							<NavLink to={`/messages`} className="d-inline-block w-100 text-center mt-0">
								<button className="btn btn-primary py-2 w-100-xs">View All Messages</button>
							</NavLink>
						</div>
					</div>
				)}
			</div>
		);
	}
}

export default connect<IMarketState, IMarketActionDispatches, MessagesProps>(
	mapMarketStateToProps,
	mapMarketDispatchToProps
)(withAuth(withRouter(Messages)));
